export default [
    {
        path: 'access-requests',
        name: 'access-requests',
        component: () => import('../pages/setting/AccessRequestsView.vue'),
        meta: { title: 'Administrator access requests' },
    },
    {
        path: "config-settings",
        name: "addconfigsettings",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/setting/AddConfigSetting.vue"
            ),
        meta: {
            title: `Settings`,
        },
    },
    {
        path: "updateadminprofile",
        name: "adminprofile",
        component: () =>
            import(
            /* webpackChunkName: "profile" */ "../pages/setting/AdminProfileView.vue"
            ),
        meta: {
            title: `Settings`,
        },
    },
    {
        path: "panel-settings",
        name: "addpanelsettings",
        component: () =>
            import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/setting/AddPanelSetting.vue"
            ),
        meta: {
            title: `Settings`,
        },
    }
];
